import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  position: -webkit-sticky;
  position: sticky;
  ${props => ((props.top || !props.bottom) ? `top: ${props.top || 0}px;` : '')}
  ${props => (props.bottom ? `bottom: ${props.bottom}px;` : '')}
`;

function Sticky({
  top, bottom, style, children,
}) {
  return (
    <StyledDiv top={top} bottom={bottom} style={style}>{children}</StyledDiv>
  );
}

export default Sticky;
